angular.module('shared').directive('patchWebsiteLinks', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function(scope) {
      return $timeout(function() {
        return angular.element('a').filter(function(i, item) {
          return item.host === window.location.host && !item.target && !item.dataset.toggle;
        }).each(function(i, item) {
          return item.target = '_self';
        });
      });
    }
  };
}]);
